
import { IExternalCalenderEvent } from "@app-types/api/externalCalendar.types";
import { IExternalCalendar } from "@app-types/websocket/externalCalender.types";
import { createAction } from "redux-act";

export const saveExternalCalendar = createAction<IExternalCalendar>('save external calendar');
export const updateExternalCalendar = createAction<IExternalCalendar>('update external calendar');
export const deleteExternalCalendar = createAction<number>('delete external calendar');

export const downloadICSData = createAction<{url: string, id: number}>("Download ICS data");

export const saveFetchedEvents = createAction<{ calendarId: string; events: IExternalCalenderEvent[] }>('Add fetched events');

export const updateFetchedEvents = createAction<{ day: string; events: IExternalCalenderEvent[] }>('Update fetched events');




// WEBPACK FOOTER //
// ./src/services/externalCalendar/externalCalendar.actions.ts